export default class ColorUtils {
  static async getColors(instance) {
    instance.loadError = false;
    try {
      const colors = await instance.$http.post('/colors/items')
      return colors.data.data
    } catch (error) {
      instance.loadError = true;
      throw new Error(error)
    }
  }
  static async getColorOptions(instance) {
    const colors = await this.getColors(instance)
    const mappedColors = colors.map((color) => ({
      value: color.id,
      text: color.name,
      color: color.color,
      image_type: color.image_type
    }))
    return mappedColors
  }
}
